export function pluralize(word: string, length: number) {
  return `${word}${length > 1 || length < -1 ? 's' : ''}`;
}

export function pluralizeHours(length: number) {
  return `${length} Hour${length > 1 || length < -1 ? 's' : ''}`;
}
